import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const videoBoxDataHooks = createDataHooks<{
  video: {}
}>('video-box')
